module.exports = __webpack_public_path__ + "static/media/righta.b0d5c227.PNG";